import React from 'react';

import { OsmMap } from './osm_map';
import { GmapsMap } from './gmaps_map';

export function Map(props) {
  return(
    props.useOsm ? <OsmMap {...props} /> : <GmapsMap {...props} />
  );
}
